import { BadgeColor, BadgeVariant, BadgeVariantSubvariantMap } from '@app/types/badge';
import { badgeColorPalette } from '@app/constants/badge';
import { ReactNode, useEffect, useState } from 'react';
import { Root } from './BadgeStyle';

type BadgeProps = {
  label: string | ReactNode | ReactNode[];
} & BadgeVariant<keyof BadgeVariantSubvariantMap>;

function Badge({ label, variant, subvariant, ...rest }: BadgeProps) {
  const [badgeColor, setBadgeColor] = useState<BadgeColor | undefined>();

  useEffect(() => {
    setBadgeColor(badgeColorPalette[variant][subvariant]);
  }, [variant, subvariant]);

  return (
    <Root
      bgColour={badgeColor?.bgHexColor}
      bgOpacity={badgeColor?.bgOpacity}
      color={badgeColor?.color}
      className='badge'
      {...rest}
    >
      {Array.isArray(label) ? (
        label.map((item, index) => <span key={index}>{item}</span>)
      ) : (
        <span>{label}</span>
      )}
    </Root>
  );
}

export default Badge;

export const getBadge = ({ label, variant, subvariant, ...rest }: BadgeProps) => {
  return <Badge label={label} variant={variant} subvariant={subvariant} {...rest} />;
};
